import { httpApi } from '@api/http.api';
import type {
    CommonTablePaginatedResponse,
    CommonTableRequest,
} from '@routes/sidebar/admin-center/___shared___/types.ts';

export type VesselEquipmentMakersRequest = CommonTableRequest;

export interface VesselEquipmentMaker {
    id: number;
    nameShort: string;
    nameFull: string | null;
    isActive: boolean;
    isBuiltIn: boolean;
    createdAtUTC: string;
}

export interface ResultsDescription {
    [k: string]: unknown;
}

export interface VesselEquipmentMakerResponse {
    data: VesselEquipmentMaker[];
    pagination: CommonTablePaginatedResponse;
    resultsDescription: ResultsDescription;
}

export interface CreateVesselEquipmentMakerRequest {
    nameShort: string;
    nameFull: string;
}

export type UpdateVesselEquipmentMakerRequest = CreateVesselEquipmentMakerRequest;

export const getApiVesselEquipmentMakers = (
    clientId: number,
    tenantAlias: string,
    payload: VesselEquipmentMakersRequest,
): Promise<VesselEquipmentMakerResponse> =>
    httpApi
        .post<VesselEquipmentMakerResponse>(
            `admin-center/clients/${clientId}/tenants/${tenantAlias}/vessel-equipment-makers/search`,
            payload,
        )
        .then(({ data }) => data);

export const createApiVesselEquipmentMaker = (
    clientId: number,
    tenantAlias: string,
    payload: CreateVesselEquipmentMakerRequest,
): Promise<VesselEquipmentMaker> =>
    httpApi
        .post<VesselEquipmentMaker>(
            `admin-center/clients/${clientId}/tenants/${tenantAlias}/vessel-equipment-makers`,
            payload,
        )
        .then(({ data }) => data);

export const updateApiVesselEquipmentMaker = (
    clientId: number,
    tenantAlias: string,
    id: number,
    payload: UpdateVesselEquipmentMakerRequest,
): Promise<VesselEquipmentMaker> =>
    httpApi
        .put<VesselEquipmentMaker>(
            `admin-center/clients/${clientId}/tenants/${tenantAlias}/vessel-equipment-makers/${id}`,
            payload,
        )
        .then(({ data }) => data);
